<template>
  <div class="px-5">
    <brand-logo class="p-5" />
  </div>
</template>

<script>
import BrandLogo from './brand-logo.vue';

export default {
  name: 'MycHeader',
  components: {
    BrandLogo,
  },
};
</script>
